import store from './../../store';

export default {
  data() {
    return {
      sysName: 'iPartyBKK',
      account: store.state.account,
    };
  },
  props: {
    logout: {
      type: Function,
      Required: true,
    },
  },
  methods: {
  },
};



// WEBPACK FOOTER //
// ./src/components/navbar/navbar.js